import styled from 'styled-components';
import {
  titleMStyle,
  titleSStyle,
  paragraphMStyle,
  labelSStyle
} from 'components/Gen.2/Typography';
import Container from 'components/Container';
import FadeUpWrapper from 'components/FadeUpWrapper';
import { sizes } from 'style';
import { colors } from 'style/theme';

export const Background = styled.div`
  position: relative;
  background-color: ${colors.portGore};
  min-height: 50svh;

  @media ${sizes.desktop} {
    background-color: transparent;
  }
`;

export const FeaturesContainer = styled(Container)`
  min-height: initial;
  display: grid;
  gap: 44px;
  row-gap: 32px;
  justify-content: center;
  max-width: 1128px;
  margin-top: -64px;
  padding: 24px 48px;

  @media ${sizes.tabletPortrait} {
    grid-template-columns: repeat(2, 1fr);
  }

  @media ${sizes.desktop} {
    grid-template-columns: repeat(4, 1fr);
  }
`;

export const Feature = styled(FadeUpWrapper)`
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 8px;
`;

export const FeatureIcon = styled.img.attrs({ alt: '' })`
  display: block;
  margin-bottom: 8px;
`;

export const FeatureTitle = styled.h5`
  ${titleSStyle}

  @media ${sizes.tabletPortrait} {
    ${titleMStyle}
  }
`;

export const FeatureBody = styled.p`
  color: ${colors.indigoLigth3};
  ${labelSStyle}

  @media ${sizes.tabletPortrait} {
    ${paragraphMStyle}
  }
`;
